package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_04_18_Day_1
import com.veldekar.components.logs.Log_2026_04_18_Day_2
import com.veldekar.components.logs.Log_2026_04_18_Day_3
import com.veldekar.components.logs.Log_2026_04_18_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-04-18")
@Composable
public fun Log_2026_04_18(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Dark Elves from The Mun",
        ogTitle = "Dark Elves from The Mun",
        date = LocalDate(2_026, 4, 18),
        aiHint = "The title is playing on the similarity between 'Mun' (a place in the campaign) and 'The Moon' (a natural satellite of Earth). The dark elves in the image are depicted as Sci-Fi characters referencing the play on words.",
        ogDescription = "The heroes learn that another band of adventurers also seeks the shard of Concar in the Gideon forest. But with Elrovir Rodiridan’s path seeking, the ability to scry shard locations, the good gods’ will, and even the favor of a few devils, the Friends of Forest are destined for victory.",
        ogImage = "images/darkElvesFromTheMun_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A detailed hand-drawn illustration of two dark elves standing before a large moon. Tressa (left) is drawn as a paladin reminiscent of Princess Leia (although we later learned she was a Barbarian) and Delia (right) is drawn as Leeloo Dallas (a character from the movie The Fifth Element).",
    ) {
        SessionDayHeader(dayId = "shimmer-25", dateString = "Shimmer 25", cardImageSrc = "flags/Mun.svg")
        Log_2026_04_18_Day_1()
        SessionDayHeader(dayId = "shimmer-26", dateString = "Shimmer 26")
        Log_2026_04_18_Day_2()
        SessionDayHeader(dayId = "shimmer-27", dateString = "Shimmer 27")
        Log_2026_04_18_Day_3()
        SessionDayHeader(dayId = "shimmer-29", dateString = "Shimmer 29")
        Log_2026_04_18_Day_4()
        SessionMediaItem(
            image = "images/darkElvesFromTheMun.webp",
            linkImage = "images/darkElvesFromTheMun.webp",
            description = "A detailed hand-drawn illustration of two dark elves standing before a large moon. Tressa (left) is drawn as a paladin reminiscent of Princess Leia (although we later learned she was a Barbarian) and Delia (right) is drawn as Leeloo Dallas (a character from the movie The Fifth Element).",
            width = 1_600,
            height = 1_329,
        )
    }
}
